var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      pointerEvents: "none",
      display: "block",
      width: "100%",
      height: "100%"
    },
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#888",
    d: "M28.486 59.97c-6.636-.57-11.563-2.328-16.322-5.825C4.444 48.472 0 39.647 0 29.987 0 15.112 10.507 2.798 25.274.367c6.029-.992 12.704.05 18.288 2.854 13.577 6.818 19.782 22.54 14.643 37.103-3.528 9.998-12.79 17.618-23.391 19.245-2.086.32-5.065.509-6.328.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M40.532 19.16h-22c-1.74 0-2.986 1.238-3 3v16c0 1.763 1.26 3 3 3h22c1.74 0 3-1.237 3-3v-16c0-1.762-1.26-3-3-3zm0 6-11 7-11-7v-3l11 7 11-7v3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareEmail);
export default __webpack_public_path__ + "static/media/shareEmail.fc3d4252b41ccddc746528b2152db670.svg";
export { ForwardRef as ReactComponent };